module.exports = __webpack_public_path__ + "img/app-store-icon.1b659262.svg";